import React, { useState, useEffect } from "react";
import { Table, Empty, Col, Row, message, Tooltip } from "antd";
import {
  BarsOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import ReplaceDate from "../../util/Extensions/DateReplaceExtension";
import { useMediaQuery } from "react-responsive";
import FirmStatusReportTableFilter from "../Filters/FirmStatusReportTableFilter";
import RequestHandler from "../../util/RequestHandler";
import { ColumnHelper } from "../../util/TableHelper";
import config from "../../util/ApiforContext";
import { odata, queryHelper } from "../Filters/Helper";

const FirmStatusReport = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [isDigitReportFirmStatus, setIsDigitReportFirmStatus] = useState();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
    RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then((response) => {
      if (response.success) {
        setIsDigitReportFirmStatus(response.data.isDigitReportFirmStatus)
      }
    });
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.post(
      `/Reports?$count=true&$skip=${skip}&$top=${take}`,
      tableDataQueryOptions.values,
      false
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    delete values["dateRange"];
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const getDecimalStringValue = (value) => (value ? value : 0);

  const goReportDetailAccountPage = (value) => {
    RequestHandler.get(`/Firm/GetById/${value}`).then((response) => {
      if (response != null) {
        !tableDataQueryOptions.values.date
          ? history.push(
              `report-firm-account-transaction/${response.id}/null/null/${
                tableDataQueryOptions.values.currencyCode
                  ? tableDataQueryOptions.values.currencyCode
                  : null
              }`
            )
          : history.push(
              `report-firm-account-transaction/${
                response.id
              }/${tableDataQueryOptions.values.date
                .replace("/", "-")
                .replace("/", "-")}/${tableDataQueryOptions.values.endDate
                .replace("/", "-")
                .replace("/", "-")}/${
                tableDataQueryOptions.values.currencyCode
                  ? tableDataQueryOptions.values.currencyCode
                  : null
              }`
            );
      }
    });
  };

  const GoReportMonthlyPaymentPage = (value) => {
    RequestHandler.get(`/Firm/GetById/${value}`).then((response) => {
      if (response != null) {
        !tableDataQueryOptions.values.date
          ? history.push(
              `report-firm-monthly-payment/${response.id}/null/null/${
                tableDataQueryOptions.values.currencyCode
                  ? tableDataQueryOptions.values.currencyCode
                  : null
              }`
            )
          : history.push(
              `report-firm-monthly-payment/${
                response.id
              }/${tableDataQueryOptions.values.date
                .replace("/", "-")
                .replace("/", "-")}/${tableDataQueryOptions.values.endDate
                .replace("/", "-")
                .replace("/", "-")}/${
                tableDataQueryOptions.values.currencyCode
                  ? tableDataQueryOptions.values.currencyCode
                  : null
              }`
            );
      }
    });
  };

  const GoReportDetailPage = (value) => {
    RequestHandler.get(`/Firm/GetById/${value}`).then((response) => {
      if (response != null) {
        !tableDataQueryOptions.values.date
          ? history.push(
            `report-firm-status-detail/${response.id}/null/null/${
              tableDataQueryOptions.values.currencyCode
                ? tableDataQueryOptions.values.currencyCode
                : null
            }`
          )
          : history.push(
            `report-firm-status-detail/${
              response.id
            }/${tableDataQueryOptions.values.date
              .replace("/", "-")
              .replace("/", "-")}/${tableDataQueryOptions.values.endDate
              .replace("/", "-")
              .replace("/", "-")}/${
              tableDataQueryOptions.values.currencyCode
                ? tableDataQueryOptions.values.currencyCode
                : null
            }`
          );
      }
    });
  };

  const goReportDetailCollectChart = () => {
    const date = ReplaceDate(
      tableDataQueryOptions.values.date
        ? tableDataQueryOptions.values.date
        : null
    );
    const endDate = ReplaceDate(
      tableDataQueryOptions.values.endDate
        ? tableDataQueryOptions.values.endDate
        : null
    );
    let { currencyCode, firmId } = tableDataQueryOptions.values;
    const {
      collectTotal,
      collectTotal2,
      collectPlanTotal,
      collectPlanTotal2,
      paymentPlanTotal,
      paymentPlanTotal2,
      paymentTotal,
      paymentTotal2,
    } = tableDataQueryOptions.values;

    currencyCode = currencyCode ? currencyCode : null;
    firmId = firmId ? firmId : null;

    history.push(
      `firm-status-report-chart-collect/${date}/${endDate}/${currencyCode}/${firmId}/${getDecimalStringValue(
        collectTotal
      )}/${getDecimalStringValue(collectTotal2)}/${getDecimalStringValue(
        collectPlanTotal
      )}/${getDecimalStringValue(collectPlanTotal2)}/${getDecimalStringValue(
        paymentPlanTotal
      )}/${getDecimalStringValue(paymentPlanTotal2)}/${getDecimalStringValue(
        paymentTotal
      )}/${getDecimalStringValue(paymentTotal2)}`
    );
  };

  const goReportDetailPaymentChart = () => {
    const date = ReplaceDate(
      tableDataQueryOptions.values.date
        ? tableDataQueryOptions.values.date
        : null
    );
    const endDate = ReplaceDate(
      tableDataQueryOptions.values.endDate
        ? tableDataQueryOptions.values.endDate
        : null
    );
    let { currencyCode, firmId } = tableDataQueryOptions.values;
    const {
      collectTotal,
      collectTotal2,
      collectPlanTotal,
      collectPlanTotal2,
      paymentPlanTotal,
      paymentPlanTotal2,
      paymentTotal,
      paymentTotal2,
    } = tableDataQueryOptions.values;

    currencyCode = currencyCode ? currencyCode : null;
    firmId = firmId ? firmId : null;

    history.push(
      `firm-status-report-chart-payment/${date}/${endDate}/${currencyCode}/${firmId}/${getDecimalStringValue(
        collectTotal
      )}/${getDecimalStringValue(collectTotal2)}/${getDecimalStringValue(
        collectPlanTotal
      )}/${getDecimalStringValue(collectPlanTotal2)}/${getDecimalStringValue(
        paymentPlanTotal
      )}/${getDecimalStringValue(paymentPlanTotal2)}/${getDecimalStringValue(
        paymentTotal
      )}/${getDecimalStringValue(paymentTotal2)}`
    );
  };

  const renderDecimal = (value) =>
    value !== null ? (isDigitReportFirmStatus ? ColumnHelper.renderDecimal(value) : ColumnHelper.renderDecimal(value).split(",")[0]) : null;

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
    RequestHandler.post(
      `/Reports/GetCollectAndPaymentPlanExcel`,
      {
        FirmId: tableDataQueryOptions.values.firmId
          ? tableDataQueryOptions.values.firmId
          : null,
        CollectTotal: tableDataQueryOptions.values.collectTotal
          ? tableDataQueryOptions.values.collectTotal
          : 0,
        CollectTotal2: tableDataQueryOptions.values.collectTotal2
          ? tableDataQueryOptions.values.collectTotal2
          : 0,
        CollectPlanTotal: tableDataQueryOptions.values.collectPlanTotal
          ? tableDataQueryOptions.values.collectPlanTotal
          : 0,
        CollectPlanTotal2: tableDataQueryOptions.values.collectPlanTotal2
          ? tableDataQueryOptions.values.collectPlanTotal2
          : 0,
        PaymentPlanTotal: tableDataQueryOptions.values.paymentPlanTotal
          ? tableDataQueryOptions.values.paymentPlanTotal
          : 0,
        PaymentPlanTotal2: tableDataQueryOptions.values.paymentPlanTotal2
          ? tableDataQueryOptions.values.paymentPlanTotal2
          : 0,
        PaymentTotal: tableDataQueryOptions.values.paymentTotal
          ? tableDataQueryOptions.values.paymentTotal
          : 0,
        PaymentTotal2: tableDataQueryOptions.values.paymentTotal2
          ? tableDataQueryOptions.values.paymentTotal2
          : 0,
        CurrencyCode: tableDataQueryOptions.values.currencyCode
          ? tableDataQueryOptions.values.currencyCode
          : null,
        Date: tableDataQueryOptions.values.date
          ? tableDataQueryOptions.values.date
          : null,
        EndDate: tableDataQueryOptions.values.endDate
          ? tableDataQueryOptions.values.endDate
          : null,
      },
      false
    ).then((response) => {
      hideMessage();
      if (response) {
        window.open(
          `${
            config.apiUrl
          }/Reports/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);
    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const columns = [
    {
      title: "Cari",
      dataIndex: "firmId",
      key: "firmId",
      align: "center",
      width: "10%",
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectPlanTotal",
      key: "collectPlanTotal",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Gerçekleşen Tahsilat",
      dataIndex: "collectTotal",
      key: "collectTotal",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Kalan Tahsilat",
      dataIndex: "remainingCollect",
      key: "remainingCollect",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Ödeme Planı",
      dataIndex: "paymentPlanTotal",
      key: "paymentPlanTotal",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Gerçekleşen Ödeme",
      dataIndex: "paymentTotal",
      key: "paymentTotal",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Kalan Ödeme",
      dataIndex: "remainingPayment",
      key: "remainingPayment",
      align: "center",
      width: "10%",
      render: renderDecimal,
    },
    {
      title: "Tahsilat Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) =>
        tableData.data.length >= 1 ? (
          <a
            onClick={() => {
              goReportDetailAccountPage(record.firmIdGuid);
            }}
            style={{ fontSize: "130%" }}
          >
            <MenuUnfoldOutlined />
          </a>
        ) : null,
    },
    {
      title: "Ödeme Detay",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) =>
        tableData.data.length >= 1 ? (
          <a
            onClick={() => {
              GoReportMonthlyPaymentPage(record.firmIdGuid);
            }}
            style={{ fontSize: "130%" }}
          >
            <MenuUnfoldOutlined style={{ color: "green" }} />
          </a>
        ) : null,
    },
    {
      title: "Tümü",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, record) =>
        tableData.data.length >= 1 ? (
          <a
            onClick={() => {
              GoReportDetailPage(record.firmIdGuid);
            }}
            style={{ fontSize: "130%" }}
          >
            <MenuUnfoldOutlined style={{ color: "red" }} />
          </a>
        ) : null,
    },
  ];
  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> CARİ DURUM RAPORU
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <FirmStatusReportTableFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        extraText="Varsayılan olarak yılın ilk gününden itibaren bugüne kadar
        TRY cinsinden veri listelenmektedir."
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        {isDesktopOrLaptop && (
          <>
            <Col flex={2}></Col>
            <Col flex={"0 250px"} style={{ marginBottom: "1%" }}>
              <a
                onClick={() => goReportDetailCollectChart()}
                style={{ fontSize: "110%", color: "black" }}
              >
                <PieChartOutlined /> Gerçekleşen Tahsilat Grafik |
              </a>
            </Col>
            <Col flex={0} style={{ marginBottom: "1%" }}>
              <a
                onClick={() => goReportDetailPaymentChart()}
                style={{ fontSize: "110%", color: "black" }}
              >
                <PieChartOutlined /> Gerçekleşen Ödeme Grafik
              </a>
            </Col>
          </>
        )}

        {isTabletOrMobileDevice && (
          <>
            <Col span={12} style={{ marginBottom: "1%" }}>
              <a
                onClick={() => goReportDetailCollectChart()}
                style={{ color: "black" }}
              >
                <PieChartOutlined /> Gerçekleşen Tahsilat Grafik
              </a>
            </Col>
            <Col span={12} style={{ marginBottom: "1%" }}>
              <a
                onClick={() => goReportDetailPaymentChart()}
                style={{ color: "black" }}
              >
                <PieChartOutlined /> Gerçekleşen Ödeme Grafik
              </a>
            </Col>
          </>
        )}
      </Row>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(_, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default FirmStatusReport;
